// @flow
import { type ActionType, createAction } from 'redux-actions';
import { Map } from 'immutable';
import AsyncValues, { type AsyncValueType } from 'lib/async-value';

export type AssignmentRecord = {
  changeStatus: ?AsyncValueType<>,
  assigned_to: ?number,
  assigned_by: ?number,
};
type State = Map<Id, AssignmentRecord>;
export type AssignmentState = State;
export const DEFAULT_STATE = Map();

export const requestAssignment = createAction(
  '@ugc-assignment/request',
  (payload: { ugcId: Id, clientId: Id, profileId: ?number }) => payload
);

export const receiveAssignment = createAction(
  '@ugc-assignment/response',
  (payload: { assigned_to: ?number, assigned_by: ?number }) => payload,
  (_, ugcId: Id) => ugcId
);

export const clearChangeStatus = createAction(
  '@ugc-assignment/clear-pending',
  (ugcId: Id) => ugcId
);

export const clearAssignment = createAction(
  '@ugc-assignment/clear',
  (ugcId: Id) => ugcId
);

export default function reducer(
  state: State = DEFAULT_STATE,
  action: ActionType<*>
) {
  switch (action.type) {
    case requestAssignment.toString(): {
      const {
        payload: { ugcId, profileId: assigned_to },
      } = (action: ActionType<typeof requestAssignment>);

      return state.set(ugcId, {
        changeStatus: AsyncValues.Pending,
        assigned_to,
      });
    }

    case receiveAssignment.toString(): {
      const { error, meta: ugcId } = (action: ActionType<
        typeof receiveAssignment
      >);
      const nextValue = error ? { changeStatus: action.payload } : {};

      return state.set(ugcId, nextValue);
    }

    case clearChangeStatus.toString(): {
      const { payload: ugcId } = (action: ActionType<typeof clearChangeStatus>);

      return state.set(ugcId, { ...state.get(ugcId), changeStatus: null });
    }

    case clearAssignment.toString(): {
      const { payload: ugcId } = (action: ActionType<typeof clearAssignment>);

      return state.remove(ugcId);
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/containers/client/ugcAssignmentReducer.js